import React, { Fragment } from "react";
import {
    AGE_GROUP_OPTIONS,
    GENDER_OPTIONS,
    LOCATION_OPTIONS,
} from "../../util/constants";
import { FilterHeader } from "./FilterHeader";
import { FilterLocation } from "./FilterLocation";
import { FilterCategory } from "./FilterCategory";
import { CloseIconWhite } from "../../util/icons";

const PlannerFilter = (props) => {
    const {
        regions,
        adFormats,
        adShapes,
        setQueryVar,
        unCheckRegion,
        setRegionQueryVar,
        variables,
        type,
        toggleFilterOpen,
        filterOpenDefault,
    } = props;

    let adFormatFileTitle = "Size";
    if (["Train", "Bus"].includes(type)) {
        adFormatFileTitle = "Ad-Format";
    }

    return (
        <div className="planner-filter__wrap">
            <div className="planner-filter__close" onClick={toggleFilterOpen}>
                <CloseIconWhite />
            </div>
            <div className="planner-filter">
                <div className="planner-filter__mobile-select">
                    <p onClick={toggleFilterOpen}>View items</p>
                </div>
                <FilterHeader {...props} />

                <div className="planner-filter__filters">
                    {!["Train", "Air"].includes(type) && (
                        <FilterLocation
                            regions={regions}
                            setQueryVar={setQueryVar}
                            unCheckRegion={unCheckRegion}
                            setRegionQueryVar={setRegionQueryVar}
                            variables={variables}
                            defaultOpen={!!filterOpenDefault}
                        />
                    )}

                    {type !== 'BasePanel' && (
                        <Fragment>
                            <FilterCategory
                                name={"adShapeIDs"}
                                title={"Shape"}
                                setQueryVar={setQueryVar}
                                options={adShapes}
                                variables={variables}
                                isMultiSelect
                            />
                            <FilterCategory
                                name={"adFormatIDs"}
                                title={adFormatFileTitle}
                                setQueryVar={setQueryVar}
                                options={adFormats}
                                variables={variables}
                                isMultiSelect
                            />
                        </Fragment>
                    )}

                    {!["Train", "Bus", "BasePanel"].includes(type) && (
                        <Fragment>
                            <FilterCategory
                                name={"gender"}
                                title={"Gender Skew"}
                                options={GENDER_OPTIONS}
                                setQueryVar={setQueryVar}
                                variables={variables}
                            />
                            <FilterCategory
                                name={"age"}
                                title={"Age Group Skew"}
                                setQueryVar={setQueryVar}
                                options={AGE_GROUP_OPTIONS}
                                variables={variables}
                            />
                            <FilterCategory
                                name={"location"}
                                title={"Category Affinity Skew"}
                                setQueryVar={setQueryVar}
                                options={LOCATION_OPTIONS}
                                variables={variables}
                            />
                        </Fragment>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PlannerFilter;
